/** Normalize faction keys to match SC Data Viewer catalog `itemCode` / `id`. */
export function normalizeFactionItemCode(value) {
  const raw = String(value || '').trim().toLowerCase();
  if (!raw) return '';
  if (raw.startsWith('factionreputation_')) return raw;
  return `factionreputation_${raw}`;
}

export function findFactionIdInCatalog(factions, { factionItemCode = '', factionLabel = '' } = {}) {
  if (!Array.isArray(factions) || !factions.length) return null;

  const normalizedCode = normalizeFactionItemCode(factionItemCode);
  if (normalizedCode) {
    const byCode = factions.find(
      (faction) =>
        normalizeFactionItemCode(faction?.id || faction?.itemCode) === normalizedCode
    );
    if (byCode?.id) return byCode.id;
  }

  const labelKey = String(factionLabel || '').trim().toLowerCase();
  if (!labelKey) return null;

  const byLabel = factions.find(
    (faction) => String(faction?.name || '').trim().toLowerCase() === labelKey
  );
  return byLabel?.id || null;
}
